import PasswordResetScreen from "../components/screens/PasswordResetScreen";

function PasswordRecovery() {
    return <PasswordResetScreen />
}

export default PasswordRecovery;